export default __webpack_public_path__ + "assets/item1.0f9961708fbef8648c21e686c3bbbe49.png";